module.exports = __webpack_public_path__ + "loanChats.4d28d49.png";